module.exports = __webpack_public_path__ + "img/square_blue.ac1c1325.svg";